// extracted by mini-css-extract-plugin
var _1 = "Avatars-moduleavatar__hCLSv";
var _2 = "Avatars-moduleavatarNegative__qcQxp";
export { _1 as "avatar", _2 as "avatarNegative" }
